<template>
  <div v-if="value"
       class="wrapper"
  >
    <div v-if="text">
      набрано <b>{{progress}}%</b> от минимальной суммы ({{actual}}{{ccy}} из {{value}}{{ccy}})
    </div>
    <div v-else>
      <v-progress-circular
          size="40"
          :color="color"
          :value="progress"
      ></v-progress-circular>
      <b class="localized-progress">{{progress}}%</b>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BuyoutMinimalSum',
  computed: {
    color: function () {
      if (this.progress < 50) {
        return 'red'
      }  else if (this.progress > 49 && this.progress < 100) {
        return 'orange'
      }
      return 'green'
    }
  },
  created: function () {
    this.progress = this.actual ? Math.round(this.actual / (this.value / 100)) : 0
  },
  data () {
    return {
      progress: 0
    }
  },
  props: {
    actual: {
      default: 0,
      type: Number
    },
    ccy: {
      type: String
    },
    text: {
      default: false,
      type: Boolean
    },
    value: {
      default: 0,
      type: Number
    }
  }
}
</script>

<style scoped>
.wrapper {
  position: relative;
}
.localized-progress {
  position: absolute;
  top: 50%;
  left: 50%;

  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  font-size: 11px;
}
</style>